import React from 'react';
import { useNavigate } from 'react-router-dom';
import LogoIcon from '../../assets/images/logo.png';
import { Helmet } from 'react-helmet-async';
import { Box, Container, Stack } from '@mui/material';

function PageNotFound() {
  const navigate = useNavigate();

  return (
    <Stack>
      <Helmet>
        <title>Home Page</title>
        <meta name="description" content="Home Page" />
      </Helmet>
    </Stack>
  );
}

export default PageNotFound;
